import { useQuery } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import http from '../../utils/Http/Http'

type UsageReportResponse = {
	max_daily_calls: number
	daily_calls: number
	max_total_calls: number
	total_calls: number
	next_unlock_at?: number | null
	next_unlock_calls?: number | null
}

const getUsageReport = async () => {
	const response = await http({
		method: 'post',
		url: '/user/usage_report',
	})
	return response.data
}

export default function useUsageReport() {
	const auth = getAuth()
	const user = auth.currentUser
	const { data, isFetching, refetch } = useQuery<UsageReportResponse>({
		queryKey: [`usage_report_${user?.uid}`],
		queryFn: getUsageReport,
	})
	return { usage: data, isFetching, refetch }
}
